import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InformationDialogBoxDataFormGroup } from './information-dialog-box-data-form-group';
import { InformationDialogBoxDataModel } from './information-dialog-box-data.model';
import { AbstractActionConfirmationDialogComponent } from '../abstract-action-confirmation-dialog/abstract-action-confirmation-dialog.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-action-confirmation-information-dialog',
  styleUrls: ['./action-confirmation-information-dialog.component.scss'],
  templateUrl: './action-confirmation-information-dialog.component.html',
  imports: [AbstractActionConfirmationDialogComponent, FormsModule, ReactiveFormsModule, MatIcon],
})
export class ActionConfirmationInformationDialogComponent {
  public data: InformationDialogBoxDataModel;
  public dialogRef = inject<MatDialogRef<ActionConfirmationInformationDialogComponent>>(MatDialogRef);
  public formGroup: FormGroup<InformationDialogBoxDataFormGroup>;
  public information: SafeHtml;

  private _data = inject<InformationDialogBoxDataModel>(MAT_DIALOG_DATA);

  public constructor() {
    const _data = this._data;
    const sanitizer = inject(DomSanitizer);

    this.data = _data;
    if (!this._data.acceptLabel) {
      this.data.acceptLabel = 'Oui';
    }
    if (!this._data.declineLabel) {
      this.data.declineLabel = 'Non';
    }

    this.information = sanitizer.bypassSecurityTrustHtml(this.data.htmlMessage);

    this._createForm();
  }

  public onAcceptClickedHandler(): void {
    if (this._data.onAccept) {
      this._data.onAccept();
    }
    this.dialogRef.close(true);
  }

  public onCloseClickedHandler(): void {
    this.dialogRef.close(true);
  }

  public onDeclineClickedHandler(): void {
    if (this._data.onDecline) {
      this._data.onDecline();
    }
    this.dialogRef.close(false);
  }

  private _createForm(): void {
    this.formGroup = new FormGroup<InformationDialogBoxDataFormGroup>({});
  }
}
